(ns manatee.ui.view
  (:require
   [manatee.admin.task-config.add.view :as add-task]
   [manatee.admin.task-config.edit.view :as edit-task]
   [manatee.admin.task-config.view :as task]
   [manatee.admin.view :as admin]
   [manatee.annotation.view :as annotation]
   [manatee.auth.view :as auth]
   [manatee.dashboard.view :as dashboard]
   [manatee.edit.view :as edit]
   [manatee.info.components :as info-components]
   [manatee.not-found :as not-found]
   [manatee.qa.view :as qa]
   [manatee.sysadmin.view :as sysadm]
   [manatee.ui.subs :as subs]
   [re-frame.core :as rf]
   [rothko.icon.component :refer [svg-sprite]]
   [rothko.theme.core :as theme]))

(defn get-content
  "Unlike sandi these views need to be required as we're not using the module loader."
  [view]
  (case view
    :manatee.admin.handlers/admin admin/page
    :manatee.task-config.handlers/task-summary task/summary-page
    :manatee.task-config.add.handlers/add-task add-task/page
    :manatee.task-config.edit.handlers/edit-task edit-task/edit-task-page
    :manatee.task-config.documents.handlers/task-documents task/documents-page
    :manatee.annotation.handlers/annotate annotation/page
    :manatee.auth.handlers/login auth/page
    :manatee.dashboard.handlers/dashboard dashboard/page
    :manatee.edit.handlers/edits edit/edits-page
    :manatee.not-found/not-found not-found/page
    :manatee.qa.handlers/item qa/item-page
    :manatee.qa.handlers/user-item-edits qa/edit-review-page
    :manatee.qa.handlers/user-item-reports qa/reported-edit-review-page
    :manatee.qa.handlers/compare-item-edits qa/compare-item-edits-page
    :manatee.qa.handlers/compare-item-group qa/compare-item-group-page
    :manatee.qa.handlers/item-group qa/item-group-page
    :manatee.sysadmin.handlers/main sysadm/main-page
    :manatee.routing.handlers/index nil
    :no-op))

(defn render-template
  []
  (let [view @(rf/subscribe [::subs/view])
        {:keys [template] :as content} (get-content view)]
    (when template
      [template {:class [(str (name view) "-page")]} content])))

(defn app
  []
  [theme/provider {:theme :manatee}
   [:<>
    [info-components/info-modal]
    [render-template]
    [svg-sprite]]])
